import React, { useEffect, useState } from "react";
import Layouts from "../../../components/Layouts";
import { Button, Modal, Space, Table, Typography, message } from "antd";
import { getDirectusClient } from "../../../lib/directus";
import { EyeOutlined, DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import { Upload } from "antd";

import Search from "antd/es/input/Search";
import {
  readItems,
  readUsers,
  updateItem,
  createItem,
  updateUser,
} from "@directus/sdk";
import { useSelector } from "react-redux";
const { Title } = Typography;

let deletecambio = false;

function Loanrepay(props) {
  const [vendedor, setVendedor] = useState({});
  const [productos, setProductos] = useState([]);
  const [prestamos, setPrestamos] = useState([]);
  //prueba

  const [serialess, setSerialess] = useState([]);

  const [serialeslist, setSerialeslist] = useState([]);
  const [modalseriales, setModalseriales] = useState(false);

  const userBodega = useSelector((state) => state.userdata.bodega?.id);

  // Add these new state variables at the top of the component
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);

  // Modify the Buscarvendedor function
  const Buscarvendedor = async (searchValue) => {
    const directus = await getDirectusClient();
    try {
      const response = await directus.request(
        readUsers({
          fields: [
            "*",
            "seriales_prestados.*",
            "seriales_prestados.producto.*",
            "seriales_prestados.producto.grupo.impuesto",
          ],
          filter: {
            _and: [
              {
                _or: [
                  {
                    first_name: {
                      _contains: searchValue,
                    },
                  },
                  {
                    last_name: {
                      _contains: searchValue,
                    },
                  },
                ],
              },
              {
                role: {
                  name: { _contains: "vendedor rutas" },
                },
              },
              {
                bodega: { id: { _eq: userBodega } },
              },
            ],
          },
        })
      );

      if (response.length > 0) {
        Modal.info({
          title: "Seleccione un vendedor",
          content: (
            <Table
              dataSource={response}
              columns={[
                {
                  title: "Nombre",
                  key: "name",
                  render: (_, record) =>
                    `${record.first_name} ${record.last_name}`,
                },
                {
                  title: "Documento",
                  dataIndex: "documento",
                  key: "documento",
                },
                {
                  title: "Acción",
                  key: "action",
                  render: (_, record) => (
                    <Button
                      type="primary"
                      onClick={() => {
                        setVendedor(record);
                        setSerialess(record.seriales_prestados || []);
                        if (!record.seriales_prestados?.length) {
                          message.info(
                            `${record.first_name} ${record.last_name} no tiene préstamos pendientes`
                          );
                        }
                        Modal.destroyAll();
                      }}
                    >
                      Seleccionar
                    </Button>
                  ),
                },
              ]}
              pagination={false}
            />
          ),
          width: 600,
          okButtonProps: { style: { display: "none" } },
        });
      } else {
        setProductos([]);
        setVendedor({});
        setSerialess([]);
        Modal.warning({
          title: "No se encontró el vendedor",
        });
      }
    } catch (err) {
      console.error(err);
      Modal.error({
        title: "Error",
        content: "Error al buscar el vendedor",
      });
    }
  };

  useEffect(() => {
    console.log("eff");

    getp();
  }, [vendedor]);
  console.log();

  const getp = async (type = null) => {
    let directus = await getDirectusClient();
    try {
      const res = await directus.request(
        readItems("prestamos", {
          fields: [
            "id",
            "tipo",
            "estado",
            "vendedor",
            "seriales.*",
            "seriales.seriales_id.*",
            "seriales.estado",
          ],
          filter: {
            _and: [
              {
                vendedor: {
                  _eq: vendedor.id,
                },
              },
              {
                tipo: {
                  _eq: "prestamo",
                },
              },
              {
                seriales: {
                  seriales_id: {
                    estado: {
                      _eq: 3,
                    },
                  },
                },
              },
            ],
          },
        })
      );

      // Check if res is valid and has items
      if (Array.isArray(res)) {
        if (type != null) {
          setPrestamos(res);

          // Only check for serials count if needed
          const countResponse = await directus.request(
            readItems("prestamos", {
              filter: {
                _and: [
                  {
                    vendedor: {
                      _eq: vendedor.id,
                    },
                  },
                  {
                    estado: {
                      _eq: "activo",
                    },
                  },
                  {
                    seriales: {
                      estado: {
                        _eq: 3,
                      },
                    },
                  },
                ],
              },
            })
          );

          // Log count for debugging
          console.log("Préstamos count:", countResponse?.length);
        }

        // Only show error modal if vendor is selected and has no loans
        if (res.length === 0 && vendedor.id) {
          message.info(
            `${vendedor.first_name} ${vendedor.last_name} no tiene préstamos pendientes`
          );
        }

        setPrestamos(res);
      } else {
        console.error("Invalid response format:", res);
        message.error("Error al obtener los préstamos");
      }
    } catch (err) {
      console.error("Error in getp:", err);
      message.error("Error al consultar los préstamos");
    }
  };

  const seriales = async (id_prestamo) => {};

  const procesarseriales = (seriales) => {
    if (!seriales || seriales.length === 0) {
      return [];
    }

    const productos = seriales.reduce((acc, obj) => {
      // Only process if estado is 3 (prestamo)
      if (obj.estado !== 3) {
        return acc;
      }

      const key = obj.producto.nombre;
      if (!acc[key]) {
        acc[key] = {
          producto: key,
          seriales: [],
          precio: 0,
          impuesto: obj.producto.grupo?.impuesto || 0,
        };
      }

      acc[key].seriales.push({ serial: obj.serial, id: obj.id });
      acc[key].precio = obj.producto.preciosinimp || 0;
      acc[key].id = obj.producto.id;

      return acc;
    }, {});

    // Only process if we have products
    if (Object.keys(productos).length === 0) {
      return [];
    }

    const productosArray = Object.values(productos);
    let total = 0;

    productosArray.forEach((producto) => {
      producto.cantidad = producto.seriales.length;
      const preciot =
        parseFloat(producto.cantidad) * parseFloat(producto.precio);
      producto.totalparcial = parseFloat(
        preciot + (preciot * producto.impuesto) / 100
      ).toFixed(2);
      total = parseFloat(total) + parseFloat(producto.totalparcial);
    });

    return productosArray;
  };

  // Add this new function to handle file processing
  const processFile = async (file, record) => {
    try {
      const text = await file.text();
      const serialNumbers = text
        .split("\n")
        .map((line) => line.trim())
        .filter((line) => line.length > 0);

      // Check if all serials in the file match the product's serials
      const productSerials = new Set(record.seriales.map((s) => s.serial));
      const invalidSerials = serialNumbers.filter(
        (serial) => !productSerials.has(serial)
      );

      if (invalidSerials.length > 0) {
        Modal.error({
          title: "Seriales inválidos",
          content: `Los siguientes seriales no pertenecen a este préstamo: ${invalidSerials.join(
            ", "
          )}`,
        });
        return;
      }

      // Get the serials to return
      const serialsToReturn = record.seriales.filter((s) =>
        serialNumbers.includes(s.serial)
      );

      const directus = await getDirectusClient();

      // Calculate total amount to be returned for these serials
      const totalToReturn =
        (serialsToReturn.length / record.seriales.length) *
        parseFloat(record.totalparcial);

      // Create return loan
      const returnLoanResponse = await directus.request(
        createItem("prestamos", {
          vendedor: vendedor.id,
          tipo: "devolver prestamo",
          estado: "devolucion",
          seriales: {
            create: serialsToReturn.map((serial) => ({
              serial_id: serial.id,
            })),
          },
        })
      );

      if (returnLoanResponse.id) {
        // Update serials status and create history entries
        for (const serial of serialsToReturn) {
          await directus.request(
            updateItem("seriales", serial.id, {
              estado: 1,
              prestamo: null,
              user: null,
            })
          );

          await directus.request(
            createItem("historial_seriales", {
              tipo: 4,
              prestamo: returnLoanResponse.id,
              serial: [serial.id],
            })
          );
        }

        // Update vendor's prestamo_usado
        await directus.request(
          updateUser(vendedor.id, {
            prestamo_usado:
              parseFloat(vendedor.prestamo_usado || 0) - totalToReturn,
          })
        );

        Modal.success({
          title: "Éxito",
          content: `${
            serialsToReturn.length
          } seriales devueltos correctamente y préstamo actualizado: -$${totalToReturn.toLocaleString()}`,
        });

        // Refresh data
        const updatedVendorData = await directus.request(
          readUsers({
            fields: [
              "*",
              "seriales_prestados.*",
              "seriales_prestados.producto.*",
              "seriales_prestados.producto.grupo.impuesto",
            ],
            filter: {
              id: { _eq: vendedor.id },
              bodega: { id: { _eq: userBodega } },
            },
          })
        );

        if (updatedVendorData && updatedVendorData[0]) {
          setVendedor(updatedVendorData[0]);
          setSerialess(updatedVendorData[0].seriales_prestados);
        }

        await getp();
      }
    } catch (error) {
      console.error("Error processing file:", error);
      Modal.error({
        title: "Error",
        content: "Error al procesar el archivo y actualizar los seriales",
      });
    }
  };

  return (
    <Layouts>
      <Title level={4}>Devolver Seriales Prestados - Rutas</Title>
      <Search
        allowClear
        placeholder="Escriba el nombre del vendedor"
        onSearch={Buscarvendedor}
        style={{ width: 400 }}
      />

      <Table
        dataSource={procesarseriales(serialess)}
        columns={[
          { title: "Producto", dataIndex: "producto" },
          { title: "Cantidad", dataIndex: "cantidad" },
          { title: "Precio unitario ", dataIndex: "precio" },
          { title: "impuesto", dataIndex: "impuesto" },
          { title: "Total parcial", dataIndex: "totalparcial" },
          {
            title: "Action",
            key: "action",
            render: (_, record) => (
              <Space size="middle">
                {
                  <Button
                    onClick={() => {
                      setSerialeslist(record.seriales);
                      setModalseriales(true);
                    }}
                    icon={<EyeOutlined />}
                    type="primary"
                  >
                    Ver seriales
                  </Button>
                }
                {/* <Button
                  disabled
                  onClick={async () => {
                    try {
                      const directus = await getDirectusClient();

                      // Calculate total amount to be returned
                      const totalToReturn = parseFloat(record.totalparcial);

                      // First create the return loan
                      const returnLoanResponse = await directus.request(
                        createItem("prestamos", {
                          vendedor: vendedor.id,
                          tipo: "devolver prestamo",
                          seriales: {
                            create: record.seriales.map((serial) => ({
                              serial_id: serial.id,
                            })),
                          },
                        })
                      );

                      if (returnLoanResponse.id) {
                        // Update all serials status and create history entries
                        let cuenta = 0;
                        let eliminados = [];

                        for (const serial of record.seriales) {
                          // Update serial status
                          const updatedSerial = await directus.request(
                            updateItem("seriales", serial.id, {
                              estado: 1,
                              prestamo: null,
                              user: null,
                            })
                          );

                          // Create history entry
                          await directus.request(
                            createItem("historial_seriales", {
                              tipo: 4,
                              prestamo: returnLoanResponse.id,
                              seriales: {
                                create: record.seriales.map((producto) => ({
                                  historial_seriales_id: "+",
                                  seriales_id: {
                                    id: producto.id,
                                  },
                                })),
                              },
                            })
                          );

                          cuenta++;
                          eliminados.push(updatedSerial);
                        }

                        // Update vendor's prestamo_usado
                        await directus.request(
                          updateUser(vendedor.id, {
                            prestamo_usado:
                              parseFloat(vendedor.prestamo_usado || 0) -
                              totalToReturn,
                          })
                        );

                        if (cuenta === record.seriales.length) {
                          Modal.success({
                            title: "Éxito",
                            content: `Seriales devueltos correctamente y préstamo actualizado: -$${totalToReturn.toLocaleString()}`,
                          });

                          // Refresh vendor data to update displayed values
                          const updatedVendorData = await directus.request(
                            readUsers({
                              fields: [
                                "*",
                                "seriales_prestados.*",
                                "seriales_prestados.producto.*",
                                "seriales_prestados.producto.grupo.impuesto",
                              ],
                              filter: {
                                id: { _eq: vendedor.id },
                                bodega: { id: { _eq: userBodega } },
                              },
                            })
                          );

                          if (updatedVendorData && updatedVendorData[0]) {
                            setVendedor(updatedVendorData[0]);
                            setSerialess(
                              updatedVendorData[0].seriales_prestados
                            );
                          }

                          // Refresh loans
                          await getp();
                        }
                      }
                    } catch (error) {
                      console.error("Error returning serials:", error);
                      Modal.error({
                        title: "Error",
                        content:
                          "Error al devolver los seriales y actualizar el préstamo",
                      });
                    }
                  }}
                  icon={<DeleteOutlined />}
                  type="primary"
                >
                  Devolver Todos los seriales del productos
                </Button> */}
                <Upload
                  accept=".txt"
                  beforeUpload={(file) => {
                    processFile(file, record);
                    return false;
                  }}
                  fileList={fileList}
                  onChange={({ fileList }) => setFileList(fileList)}
                >
                  <Button
                    icon={<UploadOutlined />}
                    loading={uploading}
                    type="primary"
                  >
                    Cargar archivo de seriales
                  </Button>
                </Upload>
              </Space>
            ),
          },
        ]}
        locale={{
          emptyText: "No hay préstamos pendientes para este vendedor",
        }}
      />

      <Modal
        title="Seriales"
        onOk={() => {
          setSerialeslist([]);
          setModalseriales(false);
          deletecambio = false;
        }}
        onCancel={() => {
          setModalseriales(false);
          deletecambio = false;
        }}
        open={modalseriales}
      >
        {serialeslist.map((serial) => {
          return (
            <Space size={"small"}>
              {" "}
              <span>{serial.serial}</span>
            </Space>
          );
        })}
      </Modal>
    </Layouts>
  );
}

export default Loanrepay;
